import labelAPI from "../../api/label"
import answerAPI from "../../api/answer"
import questionAPI from "../../api/question"
import { ApiClient } from "../../api/client"
import { getItem, setItem } from "../../plugins/localStorage"

const state = {
  stack: [],
}
const getters = {}

const actions = {
  async unstackApiCalls({ state, commit, rootState }) {
    let stack = getItem("stack")
    let unstackCount = 0
    let response = null
    for (let [index, { api, method, arg }] of stack.entries()) {
      switch (api) {
        case "label":
          await labelAPI[method](arg)
          console.log(api, method, arg)
          commit("unstack", index - unstackCount)
          unstackCount++
          break
        case "answer":
          console.log(api, method, arg)
          if (method === "newAnswers") {
            arg.forEach((answer) => {
              if (answer.user_guid_text === undefined || answer.user_guid_text === null) {
                answer.user_guid_text = rootState.pilot.user.guid_text
                let index = rootState.answers.all.findIndex((a) => a.guid === answer.guid)
                if (index !== -1) {
                  commit(
                    "answers/setUserGuid",
                    {
                      index: rootState.answers.all.findIndex((a) => a.guid === answer.guid),
                      user_guid: rootState.pilot.user.guid_text,
                    },
                    { root: true }
                  )
                }
              }
            })
          }
          await answerAPI[method](arg)
          commit("unstack", index - unstackCount)
          unstackCount++
          break
        case "question":
          if (method === "newQuestion") {
            arg.user_guid_text = rootState.pilot.user.id_text
            commit("question/setUserGuidText", rootState.pilot.user.id_text, { root: true })
            arg.event_guid_text = rootState.pilot.event_guid
            commit("question/setEventGuidText", rootState.pilot.event_guid, { root: true })
          }
          response = await questionAPI[method](arg)
          if (method === "newQuestion") {
            console.log(response)
            commit("question/setCreatedAt", response.data.question.created_at, { root: true })
            commit("question/setUpdatedAt", response.data.question.updated_at, { root: true })
          }
          console.log(api, method, arg)
          commit("unstack", index - unstackCount)
          unstackCount++
          break
      }
    }
  },

  setStackFromSaved({ commit }) {
    let stack = getItem("stack")
    if (stack) {
      commit("setStack", stack)
    }
  },
}
const mutations = {
  setStack(state, stack) {
    if (stack !== null) {
      state.stack = stack
    }
  },

  addApiCallToStack(state, apiCall) {
    state.stack.push(apiCall)
    setItem({ name: "stack", value: state.stack })
  },

  unstack(state, index) {
    state.stack.splice(index, 1)
    setItem({ name: "stack", value: state.stack })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
